import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useAnalyticsEvents as useAKAnalyticsEvents, withAnalyticsEvents as withAKAnalyticsEvents } from '@atlaskit/analytics-next';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
// for class based components
export function withAnalytics(BaseComponent) {
  function HOCComponent(props) {
    const fireAnalyticsEvent = prop => {
      return function (payload) {
        let channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'marketplace';
        return prop.createAnalyticsEvent(_objectSpread({}, payload)).fire(channel);
      };
    };
    return /*#__PURE__*/_jsx(BaseComponent, _objectSpread(_objectSpread({}, props), {}, {
      fireAnalyticsEvent: fireAnalyticsEvent(props)
    }));
  }
  return withAKAnalyticsEvents()(HOCComponent);
}

// for functional components
export const useAnalyticsEvents = () => {
  const {
    createAnalyticsEvent
  } = useAKAnalyticsEvents();
  const handleAnalyticsEvent = function handleAnalyticsEvent(payload) {
    let channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'marketplace';
    createAnalyticsEvent(_objectSpread({}, payload)).fire(channel);
  };
  return handleAnalyticsEvent;
};